var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', {
    attrs: {
      "justify": "end",
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    staticClass: "v-btn--text-fit",
    attrs: {
      "to": "/",
      "text": "",
      "disabled": _vm.lang === 'ko' ? true : false
    }
  }, [_vm._v("KR")])], 1), _c('v-col', {
    staticClass: "pa-0",
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-divider', {
    staticClass: "white h-16px",
    staticStyle: {
      "opacity": "0.5"
    },
    attrs: {
      "vertical": ""
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    staticClass: "v-btn--text-fit",
    attrs: {
      "to": "/en",
      "text": "",
      "disabled": _vm.lang === 'en' ? true : false
    }
  }, [_vm._v("EN")])], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }